import { render } from "./Example1.vue?vue&type=template&id=8c85ced2"
import script from "./Example1.vue?vue&type=script&lang=ts"
export * from "./Example1.vue?vue&type=script&lang=ts"
script.render = render

export default script